export {ContactItem as default};

/**
* Contact Item
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class ContactItem {
  /**
   * Contact id
   *
   * @public
   *
   * @type {String|undefined}
   *
   * @since 7.0.0
   */
  id;

  /**
   * Name
   *
   * @public
   *
   * @type {String|undefined}
   *
   * @since 7.0.0
   */
  name;

  /**
   * Contact type
   *
   * @public
   *
   * @type {String|undefined}
   *
   * @since 7.0.0
   */
  type;

  /**
   * Defines if contact is temporary
   *
   * A temporary contact is a contact that is created on the fly
   * and is not indexed in any contact data list
   *
   * @public
   *
   * @type {Boolean}
   *
   * @since 7.0.0
   */
  temporary;
}